const queryEvents = `query events {
  events(filter: {isVirtual: true}) {
    _id
    slug
    code
    thumbnailUrl
    startDate
    published
    name {
      en
      th
    }
    settings {
      virtualRun {
        donationPerDistance
        period {
          start
          end
        }
      }
    }
    races {
      slug
    }
  }
}
`

const queryPaticipant = `query searchParticipant($eventId: MongoID!, $search: String) {
  eventTicketItemSearch(eventId: $eventId, search: $search) {
    _id
    participant {
      profile {
        firstName
        lastName
      }
    }
  }
}
`
const queryRaces = `query getRaces($slug: String){
  races(slug: $slug)
}`

const queryTicketItems = `query getTicketItems($eventId: MongoID!, $limit: Int, $skip: Int) {
  event(_id: $eventId) {
    slug
  }
  ticketItems(filter: {eventId: $eventId}, limit: $limit, skip: $skip) {
    number
    eventId
    ticketType {
      race {
        distance
        slug
        name {
          en
        }
      }
    }
    runs {
      distance
    }
    participant {
      profile {
        firstName
        lastName
        _id
      }
      registration {
        status
      }
    }
  }
}
`
const queryCountRunner = `query getTicketItems($eventId: MongoID!) {
  participantCount(filter: {eventId: $eventId})
}`

const queryCountEcer = `query countEcer($slug: String){
  timeCount(filter: {
    slug: $slug
  })
}`

const queryEcer = `query getEcer($slug: String, $limit: Int){
  times(filter: {slug: $slug}, limit: $limit) {
    bib
    bibNumber
    link
  }
}
`

module.exports = {
  queryEvents,
  queryPaticipant,
  queryRaces,
  queryTicketItems,
  queryCountRunner,
  queryCountEcer,
  queryEcer,
}



// WEBPACK FOOTER //
// ./src/CreateEcer/query.js